import React from "react";
import { injectIntl, IntlShape } from "react-intl";
import classNames from "classnames";
import { Round } from "../../../../lib/ground-aws-graphql-core/models/Api/Inspection";
import { displayDayDDMMYYYY_HHMM } from "../../../../utils/config";
import { GroundGraphqlContextStore } from "../../../../lib/ground-aws-graphql-core";
import { getStatusBadgeElements } from "../../../../utils/round";
import Badge from "../../Badge";
import IntlMessages from "../../../../utils/messages";

interface Props {
  intl: IntlShape;
  item: Round;
  title: string;
  titleParams?: any;
  className?: string;
}

const HeaderRound = (props: Props) => {
  const { item, title, titleParams, intl, className } = props;

  const centerTimezone = GroundGraphqlContextStore.useStoreState(
    state => state.center.centerTimezone
  );

  return (
    <div className={classNames("py-3 sm:py-5 px-2 sm:px-6", className)}>
      <div className="flex flex-col">
        <div className="flex justify-between mb-5">
          <h3 className="text-18px text-ground-black-100">
            {intl.formatMessage({ id: title }, titleParams)}
          </h3>
          <div className="flex flex-col">
            <Badge
              className="mb-2"
              bgClassName={getStatusBadgeElements(item.status).backgroundColor}
              textClassName={getStatusBadgeElements(item.status).textColor}
              dataCy={`inspection-round-status-${item.status}`}
            >
              {intl.formatMessage({
                id: `page.inspection.round.status.${item.status}`,
              })}
            </Badge>
          </div>
        </div>
        <div className="text-14px text-ground-gray-100 leading-relaxed">
          <IntlMessages
            id="page.inspection.round.created_at"
            values={{
              date: displayDayDDMMYYYY_HHMM(item.created_at, centerTimezone),
            }}
          />
        </div>
        <div className="text-14px text-ground-gray-100 leading-relaxed">
          <IntlMessages
            id="page.inspection.round.finished_at"
            values={{
              date: displayDayDDMMYYYY_HHMM(item.updated_at, centerTimezone),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default injectIntl(HeaderRound);
